import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { AuthProvider } from './Components/UserAccounts/AuthProvider';
import { BrowserRouter } from 'react-router-dom';
import axios from "axios";


const root = ReactDOM.createRoot(document.getElementById('root'));
// Set global default for all axios requests
axios.defaults.withCredentials = true;
axios.defaults.baseURL = 'http://vthospitalssvc.param.cloud'; // backend

// Helper to check if request URL is an authentication endpoint
const isAuthEndpoint = (url) => {
  if (!url) return false;
  const str = String(url).toLowerCase();
  return str.includes('/login') || str.includes('/validate') || str.includes('/logout');
};

// ✅ Global axios response interceptor for automatic logout on 401
axios.interceptors.response.use(
  res => res,
  err => {
    const status = err.response?.status;
    const url = err.config?.url || "";

    if (status === 401 && !isAuthEndpoint(url)) {
      console.warn("401 Unauthorized caught by axios interceptor. Dispatching auth:session-expired.");
      window.dispatchEvent(new CustomEvent("auth:session-expired"));
    }

    return Promise.reject(err);
  }
);

// ✅ Global window.fetch interceptor for automatic logout on 401
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const response = await originalFetch(...args);
  const url = typeof args[0] === "string" ? args[0] : (args[0]?.url || "");

  if (response.status === 401 && !isAuthEndpoint(url)) {
    console.warn("401 Unauthorized caught by fetch interceptor. Dispatching auth:session-expired.");
    window.dispatchEvent(new CustomEvent("auth:session-expired"));
  }

  return response;
};

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
